import React, { ReactElement } from 'react';
import { Mutation } from '@apollo/client/react/components';

import RequestMoreInfo from 'buyside/components/presentation/Subscribe/RequestMoreInfo';

import {
  CreateEmailMutation,
  CreateEmailMutationVariables,
  CreateEmailDocument
} from 'interfaces/graphql-typings';

const RequestMoreInfoContainer = (): ReactElement => (
  <Mutation<CreateEmailMutation, CreateEmailMutationVariables> mutation={CreateEmailDocument}>
    {(createEmail): ReactElement => <RequestMoreInfo createEmail={createEmail} />}
  </Mutation>
);

export default RequestMoreInfoContainer;
